import { render, staticRenderFns } from "./routes.vue?vue&type=template&id=dc7471a0&scoped=true"
import script from "./routes.vue?vue&type=script&lang=js"
export * from "./routes.vue?vue&type=script&lang=js"
import style0 from "./routes.vue?vue&type=style&index=0&id=dc7471a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7471a0",
  null
  
)

export default component.exports